import { Container } from "./styles";
import { useAuthStore } from "../../store/auth.store";
import { HamburgerMenu } from "./HamburgerMenu";
import { useUIStore } from "../../store/ui.store";
import { NavbarMenu } from "./NavbarMenu";
import { SettingsModal } from "./SettingsModal";
import { NavbarLogo } from "./NavbarLogo";
import { useNavigate } from "react-router-dom";
import { useSettingsModalFromUrl } from "./useSettingsModalFromUrl";

type Props = {
  showHamburgerMenu?: boolean;
};

export const Navbar = (props: Props) => {
  const { showHamburgerMenu = false } = props;
  const user = useAuthStore((state) => state.user);
  const toggleSidebar = useUIStore((state) => state.toggleSidebar);
  const settingsModal = useUIStore((state) => state.settingsModal);
  const openSettingsModal = useUIStore((state) => state.openSettingsModal);
  const navigate = useNavigate();
  const { handleCloseSettingsModal } = useSettingsModalFromUrl();

  const onLogout = () => {
    navigate("/logout");
  };

  const onSettingsClick = () => {
    openSettingsModal("integrations");
  };

  return (
    <Container>
      {showHamburgerMenu && (
        <HamburgerMenu onClick={() => toggleSidebar(true)} />
      )}
      <NavbarLogo />
      <ul>
        {!!user?.email && (
          <li>
            <NavbarMenu
              onLogout={onLogout}
              onSettingsClick={onSettingsClick}
              userName={user?.name}
              userEmail={user?.email}
              userRoles={user?.roles ?? []}
              userAvatar={user?.avatar || ""}
            />
          </li>
        )}
      </ul>
      <SettingsModal
        open={settingsModal.open}
        onClose={handleCloseSettingsModal}
        initialTab={settingsModal.tab}
        highlightAppId={settingsModal.highlightAppId}
        key={`${settingsModal.tab}-${settingsModal.open}`}
      />
    </Container>
  );
};
